import { Outlet } from "react-router";

const PriceNotAllowed = () => {
  return (
    <Outlet />
  )
}

export default PriceNotAllowed;